import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ComponentFactory,
  ComponentFactoryResolver, Input,
  OnInit
} from "@angular/core";
import {BdpkConfigService} from "../../../../bdpk-common/services/bdpk-config.service";
import {DxPageHeaderOptions} from "../../../../dx-page-markup/domain/ui-options/page-header/dx-page-header-options";
import {DxAuthService} from "../../../../dx-auth/services/dx-auth.service";
import {Router} from "@angular/router";
import {DxOperationResultType} from "../../../../dx-core/domain/common/dx-operation-result-type";
import {DxAppRoutes} from "../../../../dx-core/config/dx-app-routes";
import {Observable} from "rxjs";
import {DxModalOptions} from "../../../../dx-modals/domain/ui-options/dx-modal-options";
import {DxModalResultType} from "../../../../dx-modals/domain/dx-modal-result-type";
import {fromPromise} from "rxjs/internal-compatibility";
import {PitSettingsModalComponent} from "../pit-settings-modal/pit-settings-modal.component";
import {DxModalService} from "../../../../dx-modals/services/dx-modal.service";
import {DxPageHeaderItemOptions} from "../../../../dx-page-markup/domain/ui-options/page-header/dx-page-header-item-options";

/**
 *  `PitPageHeaderComponent` - общий заголовок для всех страниц приложения (возможно кроме аварийной страницы)
 **/
@Component({
  selector: 'pit-page-header',
  templateUrl: './pit-page-header.component.html',
  styleUrls: ['./pit-page-header.component.css']
})
export class PitPageHeaderComponent implements OnInit {
  private _options: DxPageHeaderOptions;
  public pitPeriodCombo: DxPageHeaderItemOptions;


  constructor(private _configService: BdpkConfigService,
              private _authService: DxAuthService,
              private _resolver: ComponentFactoryResolver,
              private _modalsService: DxModalService,
              private _router: Router) {

  }

  ngOnInit(): void {
    this._options = this._configService.bdpkPageHeaderOptions;
    this.options.groups.forEach(group => {
      group.items.forEach(item => {
        if (item.ident === 'PIT_PERIOD_COMBO') this.pitPeriodCombo = item;
      })
    });
  }


  get options(): DxPageHeaderOptions {
    return this._options;
  }

  public onAppLogoClick(): void {
    this._router.navigate([DxAppRoutes.NAVIGATOR_ROUTE]).then();
  }

  public onNotificationsClick(): void {
    alert('Показываем уведомления!');
  }

  public onHelpClick(): void {
    alert('Показывае раздел справки!');
  }

  public onSettingsClick(): void {
    this._showSettingsForm().subscribe(result => {
      if (result && result.has('budgetPeriodName')) {
        this.pitPeriodCombo.title = result.get('budgetPeriodName');
      }
    })
  }

  public onLogoutClick(): void {
    this._authService.logout().subscribe(result => {
      if(DxOperationResultType.SUCCESS === result.type) {
        this._router.navigate([DxAppRoutes.LOGIN_ROUTE]).then();
      }
    });
  }

  private _showSettingsForm():Observable<Map<string, any>> {
    const factory: ComponentFactory<any> = this._resolver.resolveComponentFactory(PitSettingsModalComponent);
    const title: string = 'Настройки';
    const options: DxModalOptions = this._modalsService.buildEditModalOptions('tiny', 'Принять');

    const promise = new Promise<Map<string, any>>((resolve) => {
      this._modalsService.showEditByFactory(factory, null, title, options).subscribe(result => {
        if(DxModalResultType.SAVE === result.type) {
          resolve(result.data);
        } else {
          resolve(null);
        }
      })
    });
    return fromPromise<Map<string, any>>(promise);
  }

}
